import GUI, { IGUIProps } from "../../gui/GUI";
import { UpdateEvent } from "../../gui/GUIEvents";
import { usePortFilter } from "../../hooks/PortFilter";
import AccountSelect from "./AccountSelect";

export default function AccountFilter(props:IGUIProps){
    const {account,setAccount} = usePortFilter()
    const onUpdate = (e:UpdateEvent<number>) => setAccount(e.value!)
    return <AccountSelect className={GUI.joinClass(props.className)} showAll={true} value={account} onUpdate={onUpdate}/>
}